import useGetNewsPaperData from './useGetNewsPaperData'

export default useGetNewsPaperData
